var map = {
	"./blog--2018-deliverability-year-review-mailgun-festivus-miracles": 609,
	"./blog--2018-deliverability-year-review-mailgun-festivus-miracles.json": 609,
	"./blog--5-benefits-of-amp-email-for-e-commerce": 610,
	"./blog--5-benefits-of-amp-email-for-e-commerce.json": 610,
	"./blog--5-free-tickets-for-sold-out-warmgun-conference-on-november-30th-in-san-francisco": 611,
	"./blog--5-free-tickets-for-sold-out-warmgun-conference-on-november-30th-in-san-francisco.json": 611,
	"./blog--5-user-roles-access-control-permissions-mailgun-account": 612,
	"./blog--5-user-roles-access-control-permissions-mailgun-account.json": 612,
	"./blog--Mailgun-Log4j-Defense": 613,
	"./blog--Mailgun-Log4j-Defense.json": 613,
	"./blog--a-b-test-bullshit": 614,
	"./blog--a-b-test-bullshit.json": 614,
	"./blog--a-guide-to-using-mailguns-webhooks": 615,
	"./blog--a-guide-to-using-mailguns-webhooks.json": 615,
	"./blog--a-word-of-caution-for-laravel-developers": 616,
	"./blog--a-word-of-caution-for-laravel-developers.json": 616,
	"./blog--agape-charity-finds-easy-way-to-forward-email-for-volunteers-worldwide": 617,
	"./blog--agape-charity-finds-easy-way-to-forward-email-for-volunteers-worldwide.json": 617,
	"./blog--all-about-mailgun-maverick-program": 618,
	"./blog--all-about-mailgun-maverick-program.json": 618,
	"./blog--analyze-and-optimize-engagement-with-the-new-campaigns": 619,
	"./blog--analyze-and-optimize-engagement-with-the-new-campaigns.json": 619,
	"./blog--announcing-strategic-growth-investment-from-thoma-bravo": 620,
	"./blog--announcing-strategic-growth-investment-from-thoma-bravo.json": 620,
	"./blog--apple-mail-privacy-protection": 621,
	"./blog--apple-mail-privacy-protection.json": 621,
	"./blog--art-of-inboxing": 622,
	"./blog--art-of-inboxing.json": 622,
	"./blog--avoid-emails-going-to-spam": 623,
	"./blog--avoid-emails-going-to-spam.json": 623,
	"./blog--avoiding-the-blind-spots-of-missing-data-with-machine-learning": 624,
	"./blog--avoiding-the-blind-spots-of-missing-data-with-machine-learning.json": 624,
	"./blog--awkward-dealing-sudden-blacklisting": 625,
	"./blog--awkward-dealing-sudden-blacklisting.json": 625,
	"./blog--bad-email-templates-consequences-misfit-email-series": 626,
	"./blog--bad-email-templates-consequences-misfit-email-series.json": 626,
	"./blog--behind-the-scene-at-jungle-disk-reliable-email-communications-with-mailgun": 627,
	"./blog--behind-the-scene-at-jungle-disk-reliable-email-communications-with-mailgun.json": 627,
	"./blog--best-dns-blocklist-not-all-created-equal": 628,
	"./blog--best-dns-blocklist-not-all-created-equal.json": 628,
	"./blog--best-practices-for-successful-email-delivery": 629,
	"./blog--best-practices-for-successful-email-delivery.json": 629,
	"./blog--best-time-to-send-emails-code": 630,
	"./blog--best-time-to-send-emails-code.json": 630,
	"./blog--best-time-to-send-holiday-emails-investigated": 631,
	"./blog--best-time-to-send-holiday-emails-investigated.json": 631,
	"./blog--better-validations-for-better-sending": 632,
	"./blog--better-validations-for-better-sending.json": 632,
	"./blog--bimi-more-than-funny-name": 633,
	"./blog--bimi-more-than-funny-name.json": 633,
	"./blog--black-friday-cyber-monday-email-tips-how-to-stand-out-inbox-holidays": 634,
	"./blog--black-friday-cyber-monday-email-tips-how-to-stand-out-inbox-holidays.json": 634,
	"./blog--black-history-month-tech": 635,
	"./blog--black-history-month-tech.json": 635,
	"./blog--build-laravel-5-7-email-authentication-mailgun-digital-ocean": 636,
	"./blog--build-laravel-5-7-email-authentication-mailgun-digital-ocean.json": 636,
	"./blog--building-a-data-driven-approach-to-keeping-users-emails-up-to-date": 637,
	"./blog--building-a-data-driven-approach-to-keeping-users-emails-up-to-date.json": 637,
	"./blog--building-an-sms-to-email-gateway": 638,
	"./blog--building-an-sms-to-email-gateway.json": 638,
	"./blog--building-best-email-experience-flipsnack": 639,
	"./blog--building-best-email-experience-flipsnack.json": 639,
	"./blog--building-html-email-and-workflow-tips": 640,
	"./blog--building-html-email-and-workflow-tips.json": 640,
	"./blog--bulk-validations-accurate-fast": 641,
	"./blog--bulk-validations-accurate-fast.json": 641,
	"./blog--can-you-guarantee-better-email-deliverability": 642,
	"./blog--can-you-guarantee-better-email-deliverability.json": 642,
	"./blog--career-guide-woman-tech": 643,
	"./blog--career-guide-woman-tech.json": 643,
	"./blog--catch-all-email-validations": 644,
	"./blog--catch-all-email-validations.json": 644,
	"./blog--caught-in-a-phishing-line-what-we-do-and-how-you-can-protect-yourself": 645,
	"./blog--caught-in-a-phishing-line-what-we-do-and-how-you-can-protect-yourself.json": 645,
	"./blog--causes-experiences-20-increase-in-clicks": 646,
	"./blog--causes-experiences-20-increase-in-clicks.json": 646,
	"./blog--cheat-sheet-what-you-should-know-about-dedicated-ips": 647,
	"./blog--cheat-sheet-what-you-should-know-about-dedicated-ips.json": 647,
	"./blog--closing-the-loop-between-your-customer-data-and-your-email-data": 648,
	"./blog--closing-the-loop-between-your-customer-data-and-your-email-data.json": 648,
	"./blog--common-phishing-email-warning-signs": 649,
	"./blog--common-phishing-email-warning-signs.json": 649,
	"./blog--continuous-campaign-analytics": 650,
	"./blog--continuous-campaign-analytics.json": 650,
	"./blog--covid-email-communications": 651,
	"./blog--covid-email-communications.json": 651,
	"./blog--create-a-web-app-from-scratch-in-under-5-minutes-with": 652,
	"./blog--create-a-web-app-from-scratch-in-under-5-minutes-with.json": 652,
	"./blog--creating-development-environments-with-kubernetes-devgun": 653,
	"./blog--creating-development-environments-with-kubernetes-devgun.json": 653,
	"./blog--cutting-through-the-noise-when-choosing-an-esp": 654,
	"./blog--cutting-through-the-noise-when-choosing-an-esp.json": 654,
	"./blog--dark-mode-email-survey": 655,
	"./blog--dark-mode-email-survey.json": 655,
	"./blog--dedicated-shared-ips-which-one-should-you-use": 656,
	"./blog--dedicated-shared-ips-which-one-should-you-use.json": 656,
	"./blog--default-api-version-now-v3": 657,
	"./blog--default-api-version-now-v3.json": 657,
	"./blog--delivering-html-emails-mailgun-go": 658,
	"./blog--delivering-html-emails-mailgun-go.json": 658,
	"./blog--demo-meteor-based-emailer-with-geolocation-and-ua-tracking": 659,
	"./blog--demo-meteor-based-emailer-with-geolocation-and-ua-tracking.json": 659,
	"./blog--developer-designer-collaboration": 660,
	"./blog--developer-designer-collaboration.json": 660,
	"./blog--difference-between-smtp-and-api": 661,
	"./blog--difference-between-smtp-and-api.json": 661,
	"./blog--different-ways-to-build-amp-emails": 662,
	"./blog--different-ways-to-build-amp-emails.json": 662,
	"./blog--digitalchalk-leverages-mailgun-for-transactional-email-notifications": 663,
	"./blog--digitalchalk-leverages-mailgun-for-transactional-email-notifications.json": 663,
	"./blog--diving-head-first-into-the-inbox": 664,
	"./blog--diving-head-first-into-the-inbox.json": 664,
	"./blog--domain-ip-reputation-gmail-care-more-about": 665,
	"./blog--domain-ip-reputation-gmail-care-more-about.json": 665,
	"./blog--domain-reputation-and-dmarc": 666,
	"./blog--domain-reputation-and-dmarc.json": 666,
	"./blog--domain-verification-changes-for-new-and-existing-domains": 667,
	"./blog--domain-verification-changes-for-new-and-existing-domains.json": 667,
	"./blog--domain-warmup-reputation-stretch-before-you-send": 668,
	"./blog--domain-warmup-reputation-stretch-before-you-send.json": 668,
	"./blog--double-opt-in-with-php-mailgun": 669,
	"./blog--double-opt-in-with-php-mailgun.json": 669,
	"./blog--easier-implementation-updated-sdks": 670,
	"./blog--easier-implementation-updated-sdks.json": 670,
	"./blog--easily-integrate-forms-into-your-application-with-mailgun-and-form-io": 671,
	"./blog--easily-integrate-forms-into-your-application-with-mailgun-and-form-io.json": 671,
	"./blog--easily-send-email-from-your-mobile-app-using-appery-io-and-mailgun": 672,
	"./blog--easily-send-email-from-your-mobile-app-using-appery-io-and-mailgun.json": 672,
	"./blog--easy-diy-for-your-mailgun-account": 673,
	"./blog--easy-diy-for-your-mailgun-account.json": 673,
	"./blog--email-accessibility-mistakes": 674,
	"./blog--email-accessibility-mistakes.json": 674,
	"./blog--email-address-validation-with-external-services": 675,
	"./blog--email-address-validation-with-external-services.json": 675,
	"./blog--email-authentication-your-id-card-sending": 676,
	"./blog--email-authentication-your-id-card-sending.json": 676,
	"./blog--email-blasts-dos-donts-mass-email-sending": 677,
	"./blog--email-blasts-dos-donts-mass-email-sending.json": 677,
	"./blog--email-bounce-rates-shifting-focus-away-failure": 678,
	"./blog--email-bounce-rates-shifting-focus-away-failure.json": 678,
	"./blog--email-bounces-what-to-do-about-them": 679,
	"./blog--email-bounces-what-to-do-about-them.json": 679,
	"./blog--email-burst-dos-and-donts": 680,
	"./blog--email-burst-dos-and-donts.json": 680,
	"./blog--email-copy-suggestions-dont-suck-your-deliverability": 681,
	"./blog--email-copy-suggestions-dont-suck-your-deliverability.json": 681,
	"./blog--email-dark-mode": 682,
	"./blog--email-dark-mode.json": 682,
	"./blog--email-deliverability-audit": 683,
	"./blog--email-deliverability-audit.json": 683,
	"./blog--email-engagement-in-2021-key-learnings": 684,
	"./blog--email-engagement-in-2021-key-learnings.json": 684,
	"./blog--email-gateway-holes": 685,
	"./blog--email-gateway-holes.json": 685,
	"./blog--email-growth-hacks-dynamic-tweets-in-emails": 686,
	"./blog--email-growth-hacks-dynamic-tweets-in-emails.json": 686,
	"./blog--email-isnt-authentic-enough-misfit-series": 687,
	"./blog--email-isnt-authentic-enough-misfit-series.json": 687,
	"./blog--email-list-building-ground-up": 688,
	"./blog--email-list-building-ground-up.json": 688,
	"./blog--email-list-segmentation": 689,
	"./blog--email-list-segmentation.json": 689,
	"./blog--email-messaging-templates": 690,
	"./blog--email-messaging-templates.json": 690,
	"./blog--email-open-rates-decoded": 691,
	"./blog--email-open-rates-decoded.json": 691,
	"./blog--email-remains-the-most-effective-marketing-platform": 692,
	"./blog--email-remains-the-most-effective-marketing-platform.json": 692,
	"./blog--email-safe-fonts-typography-improving-accessibility-emails": 693,
	"./blog--email-safe-fonts-typography-improving-accessibility-emails.json": 693,
	"./blog--email-security-best-practices": 694,
	"./blog--email-security-best-practices.json": 694,
	"./blog--email-signup-onsite-factors": 695,
	"./blog--email-signup-onsite-factors.json": 695,
	"./blog--emails-best-of-2019": 696,
	"./blog--emails-best-of-2019.json": 696,
	"./blog--emails-best-of-2020": 697,
	"./blog--emails-best-of-2020.json": 697,
	"./blog--emails-best-of-2021": 698,
	"./blog--emails-best-of-2021.json": 698,
	"./blog--emails-not-dead-mailguns-new-podcast": 699,
	"./blog--emails-not-dead-mailguns-new-podcast.json": 699,
	"./blog--emails-not-dead-season-3": 700,
	"./blog--emails-not-dead-season-3.json": 700,
	"./blog--emoji-in-email-subject-lines-should-you-use-it": 701,
	"./blog--emoji-in-email-subject-lines-should-you-use-it.json": 701,
	"./blog--event-notification-callbacks": 702,
	"./blog--event-notification-callbacks.json": 702,
	"./blog--explicit_consent": 703,
	"./blog--explicit_consent.json": 703,
	"./blog--fml-spam-sent-from-my-account-what-do-i-do": 704,
	"./blog--fml-spam-sent-from-my-account-what-do-i-do.json": 704,
	"./blog--force-for-change-its-time-to-speak-out": 705,
	"./blog--force-for-change-its-time-to-speak-out.json": 705,
	"./blog--free-email-validation-api-for-web-forms": 706,
	"./blog--free-email-validation-api-for-web-forms.json": 706,
	"./blog--g2-reviews-how-do-users-rate-mailgun": 707,
	"./blog--g2-reviews-how-do-users-rate-mailgun.json": 707,
	"./blog--gdpr-is-coming": 708,
	"./blog--gdpr-is-coming.json": 708,
	"./blog--geolocation-and-user-agent-detection-now-available-in-web-hooks": 709,
	"./blog--geolocation-and-user-agent-detection-now-available-in-web-hooks.json": 709,
	"./blog--get-your-email-in-check-for-the-holidays": 710,
	"./blog--get-your-email-in-check-for-the-holidays.json": 710,
	"./blog--getting-started-with-mailgun-introduction-to-platform-training": 711,
	"./blog--getting-started-with-mailgun-introduction-to-platform-training.json": 711,
	"./blog--getting-started-with-our-email-templates-api": 712,
	"./blog--getting-started-with-our-email-templates-api.json": 712,
	"./blog--ghost-mitigated-patching-methodology": 713,
	"./blog--ghost-mitigated-patching-methodology.json": 713,
	"./blog--gmail-deliverability": 714,
	"./blog--gmail-deliverability.json": 714,
	"./blog--gmail-open-tracking-test-at-mailgun": 715,
	"./blog--gmail-open-tracking-test-at-mailgun.json": 715,
	"./blog--gmails-promotions-tab-how-to-get-emails-classified-as-primary": 716,
	"./blog--gmails-promotions-tab-how-to-get-emails-classified-as-primary.json": 716,
	"./blog--golangs-superior-cache-solution-memcached-redis": 717,
	"./blog--golangs-superior-cache-solution-memcached-redis.json": 717,
	"./blog--google-introducing-bimi-support-and-google-postmaster-api": 718,
	"./blog--google-introducing-bimi-support-and-google-postmaster-api.json": 718,
	"./blog--google-postmaster-tools-understanding-sender-reputation": 719,
	"./blog--google-postmaster-tools-understanding-sender-reputation.json": 719,
	"./blog--growth-hacking-email-and-mullets": 720,
	"./blog--growth-hacking-email-and-mullets.json": 720,
	"./blog--gubernator-cloud-native-distributed-rate-limiting-microservices": 721,
	"./blog--gubernator-cloud-native-distributed-rate-limiting-microservices.json": 721,
	"./blog--handle-incoming-emails-like-a-pro-mailgun-api-2-0": 722,
	"./blog--handle-incoming-emails-like-a-pro-mailgun-api-2-0.json": 722,
	"./blog--happy-festivus-email-deliverability-for-the-holiday-season": 723,
	"./blog--happy-festivus-email-deliverability-for-the-holiday-season.json": 723,
	"./blog--hard-bounces-brick-walls-failure": 724,
	"./blog--hard-bounces-brick-walls-failure.json": 724,
	"./blog--hardware-fun-building-an-email-controlled-gun-for": 725,
	"./blog--hardware-fun-building-an-email-controlled-gun-for.json": 725,
	"./blog--heres-a-concept-free-plan-versus-concept-plan": 726,
	"./blog--heres-a-concept-free-plan-versus-concept-plan.json": 726,
	"./blog--high-performance-mailgun": 727,
	"./blog--high-performance-mailgun.json": 727,
	"./blog--hit-your-target-with-ongage-and-mailgun": 728,
	"./blog--hit-your-target-with-ongage-and-mailgun.json": 728,
	"./blog--honeypots": 729,
	"./blog--honeypots.json": 729,
	"./blog--how-and-why-we-adopted-service-mesh-with-vulcand-and-nginx": 730,
	"./blog--how-and-why-we-adopted-service-mesh-with-vulcand-and-nginx.json": 730,
	"./blog--how-behavioral-onboarding-emails-increased-product-usage-for-mailgun": 731,
	"./blog--how-behavioral-onboarding-emails-increased-product-usage-for-mailgun.json": 731,
	"./blog--how-connection-pooling-helped-us-cut-delivery-time-in-half-offer-opportunistic-tls": 732,
	"./blog--how-connection-pooling-helped-us-cut-delivery-time-in-half-offer-opportunistic-tls.json": 732,
	"./blog--how-covid-affected-email-sending": 733,
	"./blog--how-covid-affected-email-sending.json": 733,
	"./blog--how-fast-spammers-send-2": 734,
	"./blog--how-fast-spammers-send-2.json": 734,
	"./blog--how-geogram-built-a-free-group-email-service-using-yii-for-php-with-mysql": 735,
	"./blog--how-geogram-built-a-free-group-email-service-using-yii-for-php-with-mysql.json": 735,
	"./blog--how-kanban2go-fulfills-zawinskis-law": 736,
	"./blog--how-kanban2go-fulfills-zawinskis-law.json": 736,
	"./blog--how-node-js-app-cloud-monitoring-uses-the-mailgun-api": 737,
	"./blog--how-node-js-app-cloud-monitoring-uses-the-mailgun-api.json": 737,
	"./blog--how-quickly-can-mailgun-process-my-messages-introducing-the-rapid-fire-throughput-sla": 738,
	"./blog--how-quickly-can-mailgun-process-my-messages-introducing-the-rapid-fire-throughput-sla.json": 738,
	"./blog--how-ruby-based-dnsimple-uses-mailguns-api-to-create-2": 739,
	"./blog--how-ruby-based-dnsimple-uses-mailguns-api-to-create-2.json": 739,
	"./blog--how-ruby-based-vero-uses-mailguns-campaign-analytics": 740,
	"./blog--how-ruby-based-vero-uses-mailguns-campaign-analytics.json": 740,
	"./blog--how-tealeaf-academy-increased-student-engagement-3x": 741,
	"./blog--how-tealeaf-academy-increased-student-engagement-3x.json": 741,
	"./blog--how-to-build-an-email-list-the-right-way": 742,
	"./blog--how-to-build-an-email-list-the-right-way.json": 742,
	"./blog--how-to-deliver-email": 743,
	"./blog--how-to-deliver-email.json": 743,
	"./blog--how-to-effectively-use-webhooks-for-email-delivery": 744,
	"./blog--how-to-effectively-use-webhooks-for-email-delivery.json": 744,
	"./blog--how-to-get-ip-domain-off-email-blacklist": 745,
	"./blog--how-to-get-ip-domain-off-email-blacklist.json": 745,
	"./blog--how-to-improve-email-click-through-rates": 746,
	"./blog--how-to-improve-email-click-through-rates.json": 746,
	"./blog--how-to-improve-email-open-rates": 747,
	"./blog--how-to-improve-email-open-rates.json": 747,
	"./blog--how-to-send-transactional-email-in-a-nodejs-app-using-the-mailgun-api": 748,
	"./blog--how-to-send-transactional-email-in-a-nodejs-app-using-the-mailgun-api.json": 748,
	"./blog--how-to-view-your-messages": 749,
	"./blog--how-to-view-your-messages.json": 749,
	"./blog--how-use-parallel-programming": 750,
	"./blog--how-use-parallel-programming.json": 750,
	"./blog--how-userfox-sends-tracks-emails-in-their-ruby-app": 751,
	"./blog--how-userfox-sends-tracks-emails-in-their-ruby-app.json": 751,
	"./blog--how-uservoice-solve-their-incoming-email-problem": 752,
	"./blog--how-uservoice-solve-their-incoming-email-problem.json": 752,
	"./blog--how-we-built-a-lucene-inspired-parser-in-go": 753,
	"./blog--how-we-built-a-lucene-inspired-parser-in-go.json": 753,
	"./blog--how-zapier-uses-mailgun-to-send-emails": 754,
	"./blog--how-zapier-uses-mailgun-to-send-emails.json": 754,
	"./blog--http-2-cleartext-h2c-client-example-go": 755,
	"./blog--http-2-cleartext-h2c-client-example-go.json": 755,
	"./blog--http-crash-course": 756,
	"./blog--http-crash-course.json": 756,
	"./blog--https-innovation-and-optimization": 757,
	"./blog--https-innovation-and-optimization.json": 757,
	"./blog--ignored-emails-low-sending-self-esteem": 758,
	"./blog--ignored-emails-low-sending-self-esteem.json": 758,
	"./blog--implement-dmarc": 759,
	"./blog--implement-dmarc.json": 759,
	"./blog--improve-wordpress-email": 760,
	"./blog--improve-wordpress-email.json": 760,
	"./blog--improve-your-email-delivery-rate": 761,
	"./blog--improve-your-email-delivery-rate.json": 761,
	"./blog--inbound-email-routing-in-php": 762,
	"./blog--inbound-email-routing-in-php.json": 762,
	"./blog--inbox-placement-beta-announcement": 763,
	"./blog--inbox-placement-beta-announcement.json": 763,
	"./blog--inbox-placement-delivery-made-simple": 764,
	"./blog--inbox-placement-delivery-made-simple.json": 764,
	"./blog--inboxready-salesforce-integration": 765,
	"./blog--inboxready-salesforce-integration.json": 765,
	"./blog--infrastructure-black-friday": 766,
	"./blog--infrastructure-black-friday.json": 766,
	"./blog--inside-the-seedy-underworld-of-spammers-and-phishers": 767,
	"./blog--inside-the-seedy-underworld-of-spammers-and-phishers.json": 767,
	"./blog--intelligent-email-forwarding-with-mailgun": 768,
	"./blog--intelligent-email-forwarding-with-mailgun.json": 768,
	"./blog--international-womens-day": 769,
	"./blog--international-womens-day.json": 769,
	"./blog--internet-security-defending-against-spam": 770,
	"./blog--internet-security-defending-against-spam.json": 770,
	"./blog--interview-with-a-tam": 771,
	"./blog--interview-with-a-tam.json": 771,
	"./blog--introducing-a-new-cross-platform-debugger-for-go": 772,
	"./blog--introducing-a-new-cross-platform-debugger-for-go.json": 772,
	"./blog--introducing-inboxready": 773,
	"./blog--introducing-inboxready.json": 773,
	"./blog--introducing-pathwire": 774,
	"./blog--introducing-pathwire.json": 774,
	"./blog--introducing-the-mailgun-module-for-drupal": 775,
	"./blog--introducing-the-mailgun-module-for-drupal.json": 775,
	"./blog--ip-warm-up": 776,
	"./blog--ip-warm-up.json": 776,
	"./blog--learning-a-new-language-mailgun-is-too": 777,
	"./blog--learning-a-new-language-mailgun-is-too.json": 777,
	"./blog--lemmacmd-simple-file-encryption-tool": 778,
	"./blog--lemmacmd-simple-file-encryption-tool.json": 778,
	"./blog--life-post-acquisition-a-startup-engineers-perspective": 779,
	"./blog--life-post-acquisition-a-startup-engineers-perspective.json": 779,
	"./blog--lock-it-down-2-factor-authentication-account-security": 780,
	"./blog--lock-it-down-2-factor-authentication-account-security.json": 780,
	"./blog--machine-learning-for-everyday-tasks": 781,
	"./blog--machine-learning-for-everyday-tasks.json": 781,
	"./blog--mailbox-spam-filters": 782,
	"./blog--mailbox-spam-filters.json": 782,
	"./blog--mailchimp-shopify-split-what-do-you-do-now": 783,
	"./blog--mailchimp-shopify-split-what-do-you-do-now.json": 783,
	"./blog--mailgun-acquires-european-competitor-mailjet": 784,
	"./blog--mailgun-acquires-european-competitor-mailjet.json": 784,
	"./blog--mailgun-and-heartbleed": 785,
	"./blog--mailgun-and-heartbleed.json": 785,
	"./blog--mailgun-announces-improvements-to-logs-feature-to-increase-visibility-into-deliverability-problems": 786,
	"./blog--mailgun-announces-improvements-to-logs-feature-to-increase-visibility-into-deliverability-problems.json": 786,
	"./blog--mailgun-api-2-0-forget-mime": 787,
	"./blog--mailgun-api-2-0-forget-mime.json": 787,
	"./blog--mailgun-api-outage-post-mortem-august-2016": 788,
	"./blog--mailgun-api-outage-post-mortem-august-2016.json": 788,
	"./blog--mailgun-authentication-service-post-mortem-july-2018": 789,
	"./blog--mailgun-authentication-service-post-mortem-july-2018.json": 789,
	"./blog--mailgun-becomes-an-independent-company": 790,
	"./blog--mailgun-becomes-an-independent-company.json": 790,
	"./blog--mailgun-campaign-analytics-taking-analytics-beyond": 791,
	"./blog--mailgun-campaign-analytics-taking-analytics-beyond.json": 791,
	"./blog--mailgun-docs-are-now-open-source": 792,
	"./blog--mailgun-docs-are-now-open-source.json": 792,
	"./blog--mailgun-dyspatch-building-a-bridge-between-developers-and-marketers": 793,
	"./blog--mailgun-dyspatch-building-a-bridge-between-developers-and-marketers.json": 793,
	"./blog--mailgun-elasticsearch": 794,
	"./blog--mailgun-elasticsearch.json": 794,
	"./blog--mailgun-festivus-the-airing-of-grievances-for-black-friday-marketing-emails": 795,
	"./blog--mailgun-festivus-the-airing-of-grievances-for-black-friday-marketing-emails.json": 795,
	"./blog--mailgun-for-marketers-leveraging-email-marketing-platform": 796,
	"./blog--mailgun-for-marketers-leveraging-email-marketing-platform.json": 796,
	"./blog--mailgun-github-student-developer-pack": 797,
	"./blog--mailgun-github-student-developer-pack.json": 797,
	"./blog--mailgun-hack-day-making-our-developer-docs-smarter": 798,
	"./blog--mailgun-hack-day-making-our-developer-docs-smarter.json": 798,
	"./blog--mailgun-in-zap": 799,
	"./blog--mailgun-in-zap.json": 799,
	"./blog--mailgun-ip-pools-domain-keys": 800,
	"./blog--mailgun-ip-pools-domain-keys.json": 800,
	"./blog--mailgun-is-being-acquired-by-rackspace": 801,
	"./blog--mailgun-is-being-acquired-by-rackspace.json": 801,
	"./blog--mailgun-is-live": 802,
	"./blog--mailgun-is-live.json": 802,
	"./blog--mailgun-joins-sinch": 803,
	"./blog--mailgun-joins-sinch.json": 803,
	"./blog--mailgun-launches-new-reporting-dashboard": 804,
	"./blog--mailgun-launches-new-reporting-dashboard.json": 804,
	"./blog--mailgun-post-mortem-may-2016": 805,
	"./blog--mailgun-post-mortem-may-2016.json": 805,
	"./blog--mailgun-post-mortem-september-2014": 806,
	"./blog--mailgun-post-mortem-september-2014.json": 806,
	"./blog--mailgun-rolls-out-changes-to-email-validation-api-including-new-pricing-model-and-features": 807,
	"./blog--mailgun-rolls-out-changes-to-email-validation-api-including-new-pricing-model-and-features.json": 807,
	"./blog--mailgun-security-incident-and-important-customer-information": 808,
	"./blog--mailgun-security-incident-and-important-customer-information.json": 808,
	"./blog--mailgun-sendwithus-google-hangout-recording": 809,
	"./blog--mailgun-sendwithus-google-hangout-recording.json": 809,
	"./blog--mailgun-supports-amp-email": 810,
	"./blog--mailgun-supports-amp-email.json": 810,
	"./blog--mailgun-validations-alias": 811,
	"./blog--mailgun-validations-alias.json": 811,
	"./blog--mailgun-validations-improved-performance-eu": 812,
	"./blog--mailgun-validations-improved-performance-eu.json": 812,
	"./blog--mailgun-year-in-review-2019": 813,
	"./blog--mailgun-year-in-review-2019.json": 813,
	"./blog--mailguns-covid-19-plan-of-action": 814,
	"./blog--mailguns-covid-19-plan-of-action.json": 814,
	"./blog--mailguns-new-blog-platform-is-hosted-on-ghost": 815,
	"./blog--mailguns-new-blog-platform-is-hosted-on-ghost.json": 815,
	"./blog--mailguns-uservoice-new-face": 816,
	"./blog--mailguns-uservoice-new-face.json": 816,
	"./blog--mailpets-for-the-love-of-animals": 817,
	"./blog--mailpets-for-the-love-of-animals.json": 817,
	"./blog--make-email-accessibility-your-new-years-resolution": 818,
	"./blog--make-email-accessibility-your-new-years-resolution.json": 818,
	"./blog--mes-herencia-hispana": 819,
	"./blog--mes-herencia-hispana.json": 819,
	"./blog--message-level-email-tracking-and-more": 820,
	"./blog--message-level-email-tracking-and-more.json": 820,
	"./blog--migrating-from-mandrill-to-mailgun": 821,
	"./blog--migrating-from-mandrill-to-mailgun.json": 821,
	"./blog--migrating-to-the-heroku-mailgun-add-on": 822,
	"./blog--migrating-to-the-heroku-mailgun-add-on.json": 822,
	"./blog--migrating-wordpress-to-ghost-blog": 823,
	"./blog--migrating-wordpress-to-ghost-blog.json": 823,
	"./blog--mission-to-mars-pycon-2014": 824,
	"./blog--mission-to-mars-pycon-2014.json": 824,
	"./blog--multi-user-access-now-available-for-mailgun-customers": 825,
	"./blog--multi-user-access-now-available-for-mailgun-customers.json": 825,
	"./blog--native-mailgun-integration-lets-meteor-apps-send-email": 826,
	"./blog--native-mailgun-integration-lets-meteor-apps-send-email.json": 826,
	"./blog--new-email-analytics-features-to-answer-your-performance-questions": 827,
	"./blog--new-email-analytics-features-to-answer-your-performance-questions.json": 827,
	"./blog--new-events-api-detailed-email-tracking-and-search": 828,
	"./blog--new-events-api-detailed-email-tracking-and-search.json": 828,
	"./blog--new-mailgun-build-is-out": 829,
	"./blog--new-mailgun-build-is-out.json": 829,
	"./blog--new-mailgun-pricing-no-more-minimums-features-for-all": 830,
	"./blog--new-mailgun-pricing-no-more-minimums-features-for-all.json": 830,
	"./blog--no-reply-emails-brick-wall-email-communication": 831,
	"./blog--no-reply-emails-brick-wall-email-communication.json": 831,
	"./blog--not-that-into-you-disengaged-mailing-list-subscribers": 832,
	"./blog--not-that-into-you-disengaged-mailing-list-subscribers.json": 832,
	"./blog--objective-c-mailgun-sdk-now-available": 833,
	"./blog--objective-c-mailgun-sdk-now-available.json": 833,
	"./blog--open-sourcing-our-email-signature-parsing-library": 834,
	"./blog--open-sourcing-our-email-signature-parsing-library.json": 834,
	"./blog--opening-the-envelope-on-mailguns-new-ui": 835,
	"./blog--opening-the-envelope-on-mailguns-new-ui.json": 835,
	"./blog--our-values-in-action": 836,
	"./blog--our-values-in-action.json": 836,
	"./blog--outgoing-message-security-settings-now-available-in-the-control-panel": 837,
	"./blog--outgoing-message-security-settings-now-available-in-the-control-panel.json": 837,
	"./blog--page-views-vs-engagement": 838,
	"./blog--page-views-vs-engagement.json": 838,
	"./blog--parse-partners-with-mailgun-for-simple-integration": 839,
	"./blog--parse-partners-with-mailgun-for-simple-integration.json": 839,
	"./blog--password-meters-are-not-for-humans": 840,
	"./blog--password-meters-are-not-for-humans.json": 840,
	"./blog--pathwire-mavericks": 841,
	"./blog--pathwire-mavericks.json": 841,
	"./blog--php-how-to-use-mailgun-efficiently": 842,
	"./blog--php-how-to-use-mailgun-efficiently.json": 842,
	"./blog--preparing-your-email-infrastructure-correctly": 843,
	"./blog--preparing-your-email-infrastructure-correctly.json": 843,
	"./blog--privacy-matters-data-safety": 844,
	"./blog--privacy-matters-data-safety.json": 844,
	"./blog--product-update-dashboard-ui-improvements": 845,
	"./blog--product-update-dashboard-ui-improvements.json": 845,
	"./blog--product-update-log-details-in-the-control-panel-and-default-encrypted-email-delivery": 846,
	"./blog--product-update-log-details-in-the-control-panel-and-default-encrypted-email-delivery.json": 846,
	"./blog--product-update-message-timeline-and-improvements-to-event-logs": 847,
	"./blog--product-update-message-timeline-and-improvements-to-event-logs.json": 847,
	"./blog--product-update-new-postbin-for-debugging-webhooks": 848,
	"./blog--product-update-new-postbin-for-debugging-webhooks.json": 848,
	"./blog--product-updates-week-of-412013": 849,
	"./blog--product-updates-week-of-412013.json": 849,
	"./blog--project-hellfire-spam-d-o-a": 850,
	"./blog--project-hellfire-spam-d-o-a.json": 850,
	"./blog--promote-strategic-email-engagement": 851,
	"./blog--promote-strategic-email-engagement.json": 851,
	"./blog--pseudonymization-and-you-optimizing-data-protection": 852,
	"./blog--pseudonymization-and-you-optimizing-data-protection.json": 852,
	"./blog--python-tutorial-how-imgpage-lets-you-upload-25-mb": 853,
	"./blog--python-tutorial-how-imgpage-lets-you-upload-25-mb.json": 853,
	"./blog--q4-sending-cant-pinned-down-mailgun-festivus-feats-strength": 854,
	"./blog--q4-sending-cant-pinned-down-mailgun-festivus-feats-strength.json": 854,
	"./blog--quick-tips-getting-started-mailgun": 855,
	"./blog--quick-tips-getting-started-mailgun.json": 855,
	"./blog--recent-product-updates": 856,
	"./blog--recent-product-updates.json": 856,
	"./blog--register-for-the-webcast-using-email-to-send-push": 857,
	"./blog--register-for-the-webcast-using-email-to-send-push.json": 857,
	"./blog--reliable-linux-server-alerts-with-mailgun": 858,
	"./blog--reliable-linux-server-alerts-with-mailgun.json": 858,
	"./blog--responsive-email-templates-you-can-get-creative-with": 859,
	"./blog--responsive-email-templates-you-can-get-creative-with.json": 859,
	"./blog--restful-api": 860,
	"./blog--restful-api.json": 860,
	"./blog--reverse-dns-white-labeling-hello-my-name-is": 861,
	"./blog--reverse-dns-white-labeling-hello-my-name-is.json": 861,
	"./blog--risk-free-email-validation-from-mailgun": 862,
	"./blog--risk-free-email-validation-from-mailgun.json": 862,
	"./blog--same-api-new-tricks-get-event-notifications-just-in-time-with-webhooks": 863,
	"./blog--same-api-new-tricks-get-event-notifications-just-in-time-with-webhooks.json": 863,
	"./blog--saml-sso-sign-on-available": 864,
	"./blog--saml-sso-sign-on-available.json": 864,
	"./blog--santa-came-to-mailgun-early-everyone-gets-new-logs": 865,
	"./blog--santa-came-to-mailgun-early-everyone-gets-new-logs.json": 865,
	"./blog--scary-sending-mailgun-halloween-2018": 866,
	"./blog--scary-sending-mailgun-halloween-2018.json": 866,
	"./blog--scheduled-email-delivery-mailgun-nodejs": 867,
	"./blog--scheduled-email-delivery-mailgun-nodejs.json": 867,
	"./blog--security-guide-basic-infrastructure-security": 868,
	"./blog--security-guide-basic-infrastructure-security.json": 868,
	"./blog--segmentation-validations-email-list-cleaning": 869,
	"./blog--segmentation-validations-email-list-cleaning.json": 869,
	"./blog--send-time-optimization-announcement": 870,
	"./blog--send-time-optimization-announcement.json": 870,
	"./blog--sending-email-using-the-mailgun-php-api": 871,
	"./blog--sending-email-using-the-mailgun-php-api.json": 871,
	"./blog--sending-millions-of-job-alerts-24-7-with-the-mailgun-email-ap": 872,
	"./blog--sending-millions-of-job-alerts-24-7-with-the-mailgun-email-ap.json": 872,
	"./blog--sending-wrong-segment-misfit-email-series": 873,
	"./blog--sending-wrong-segment-misfit-email-series.json": 873,
	"./blog--sendwithus-turns-mailgun-into-a-fully-featured-marketing-platform": 874,
	"./blog--sendwithus-turns-mailgun-into-a-fully-featured-marketing-platform.json": 874,
	"./blog--session-awareness-account-management-how-active-are-you": 875,
	"./blog--session-awareness-account-management-how-active-are-you.json": 875,
	"./blog--set-up-message-queue-asynchronous-sending": 876,
	"./blog--set-up-message-queue-asynchronous-sending.json": 876,
	"./blog--simplifying-the-complex-concept-of-email-rendering": 877,
	"./blog--simplifying-the-complex-concept-of-email-rendering.json": 877,
	"./blog--simplifying-the-complex-the-basics-of-transactional-email-dynamic-content": 878,
	"./blog--simplifying-the-complex-the-basics-of-transactional-email-dynamic-content.json": 878,
	"./blog--sinch-to-acquire-pathwire": 879,
	"./blog--sinch-to-acquire-pathwire.json": 879,
	"./blog--snack-delivery-machine-part-1-mechanics": 880,
	"./blog--snack-delivery-machine-part-1-mechanics.json": 880,
	"./blog--snack-delivery-machine-part-2-the-electronics-and-tech": 881,
	"./blog--snack-delivery-machine-part-2-the-electronics-and-tech.json": 881,
	"./blog--soft-bounces-mysteries-failures": 882,
	"./blog--soft-bounces-mysteries-failures.json": 882,
	"./blog--spam-traps-what-you-should-know": 883,
	"./blog--spam-traps-what-you-should-know.json": 883,
	"./blog--spf-records-basics": 884,
	"./blog--spf-records-basics.json": 884,
	"./blog--spooky-sending-halloween-2019": 885,
	"./blog--spooky-sending-halloween-2019.json": 885,
	"./blog--store-a-temporary-mailbox-for-all-your-incoming-email": 886,
	"./blog--store-a-temporary-mailbox-for-all-your-incoming-email.json": 886,
	"./blog--stress-testing-http-with-twisted-python-and-treq": 887,
	"./blog--stress-testing-http-with-twisted-python-and-treq.json": 887,
	"./blog--sunset-policies-unengaged-recipients": 888,
	"./blog--sunset-policies-unengaged-recipients.json": 888,
	"./blog--supply-chain-email-communication": 889,
	"./blog--supply-chain-email-communication.json": 889,
	"./blog--support-around-clock-solving-24-7-support-model": 890,
	"./blog--support-around-clock-solving-24-7-support-model.json": 890,
	"./blog--swap-out-your-api-keys-with-no-downtime": 891,
	"./blog--swap-out-your-api-keys-with-no-downtime.json": 891,
	"./blog--tags-explained-gaining-useful-insights-from-email-segmentation": 892,
	"./blog--tags-explained-gaining-useful-insights-from-email-segmentation.json": 892,
	"./blog--taking-flight-mailgun-customer-io-accounce-partnership": 893,
	"./blog--taking-flight-mailgun-customer-io-accounce-partnership.json": 893,
	"./blog--textmagic-improves-deliverability-rate-with-mailgun": 894,
	"./blog--textmagic-improves-deliverability-rate-with-mailgun.json": 894,
	"./blog--the-basics-of-email-subdomains": 895,
	"./blog--the-basics-of-email-subdomains.json": 895,
	"./blog--the-benefits-of-email-automation": 896,
	"./blog--the-benefits-of-email-automation.json": 896,
	"./blog--the-bug-hunt-is-on-mailgun-goes-public-with-bugcrowd": 897,
	"./blog--the-bug-hunt-is-on-mailgun-goes-public-with-bugcrowd.json": 897,
	"./blog--the-evolution-of-email-deliverability": 898,
	"./blog--the-evolution-of-email-deliverability.json": 898,
	"./blog--the-future-of-email-bimi-and-amp": 899,
	"./blog--the-future-of-email-bimi-and-amp.json": 899,
	"./blog--the-official-go-sdk-available-now": 900,
	"./blog--the-official-go-sdk-available-now.json": 900,
	"./blog--the-official-mailgun-ruby-sdk-is-here": 901,
	"./blog--the-official-mailgun-ruby-sdk-is-here.json": 901,
	"./blog--the-php-sdk-the-first-of-many-official-mailgun-sdks": 902,
	"./blog--the-php-sdk-the-first-of-many-official-mailgun-sdks.json": 902,
	"./blog--tips-better-holiday-email-templates": 903,
	"./blog--tips-better-holiday-email-templates.json": 903,
	"./blog--tips-tricks-avoiding-gmail-spam-filtering-when-using-ruby-on-rails-action-mailer": 904,
	"./blog--tips-tricks-avoiding-gmail-spam-filtering-when-using-ruby-on-rails-action-mailer.json": 904,
	"./blog--tips-tricks-guide-to-using-regular-expressions-to-filter-incoming-email-2": 905,
	"./blog--tips-tricks-guide-to-using-regular-expressions-to-filter-incoming-email-2.json": 905,
	"./blog--tips-tricks-scheduling-email-delivery": 906,
	"./blog--tips-tricks-scheduling-email-delivery.json": 906,
	"./blog--tls-connection-control": 907,
	"./blog--tls-connection-control.json": 907,
	"./blog--tls-version-1-0-and-1-1-deprecation": 908,
	"./blog--tls-version-1-0-and-1-1-deprecation.json": 908,
	"./blog--together-at-last-postman-meets-mailgun": 909,
	"./blog--together-at-last-postman-meets-mailgun.json": 909,
	"./blog--top-email-clients-apps-of-2021": 910,
	"./blog--top-email-clients-apps-of-2021.json": 910,
	"./blog--tracking-replies-in-mailgun-or-any-other-email": 911,
	"./blog--tracking-replies-in-mailgun-or-any-other-email.json": 911,
	"./blog--transactional-emails-marketing-emails-rep-battle": 912,
	"./blog--transactional-emails-marketing-emails-rep-battle.json": 912,
	"./blog--transactional-html-email-templates": 913,
	"./blog--transactional-html-email-templates.json": 913,
	"./blog--triggered-email-program": 914,
	"./blog--triggered-email-program.json": 914,
	"./blog--try-out-our-newa-list-subscription-feature-for-wordpress": 915,
	"./blog--try-out-our-newa-list-subscription-feature-for-wordpress.json": 915,
	"./blog--turnkey-mailing-list-applet-using-the-mailgun-php-sdk": 916,
	"./blog--turnkey-mailing-list-applet-using-the-mailgun-php-sdk.json": 916,
	"./blog--understanding-dkim-how-it-works": 917,
	"./blog--understanding-dkim-how-it-works.json": 917,
	"./blog--updates-the-mailgun-stats-api": 918,
	"./blog--updates-the-mailgun-stats-api.json": 918,
	"./blog--using-data-build-better-triggered-email-campaigns": 919,
	"./blog--using-data-build-better-triggered-email-campaigns.json": 919,
	"./blog--using-mailgun-with-capistrano-recipes": 920,
	"./blog--using-mailgun-with-capistrano-recipes.json": 920,
	"./blog--view-time-optimization-mailgun-partners-verizon-media": 921,
	"./blog--view-time-optimization-mailgun-partners-verizon-media.json": 921,
	"./blog--view-your-messages-in-the-mailgun-control-panel": 922,
	"./blog--view-your-messages-in-the-mailgun-control-panel.json": 922,
	"./blog--vulnerability-management": 923,
	"./blog--vulnerability-management.json": 923,
	"./blog--we-have-a-new-region-in-europe-yall": 924,
	"./blog--we-have-a-new-region-in-europe-yall.json": 924,
	"./blog--we-just-open-sourced-flanker-our-python-email-address-and-mime-parsing-library": 925,
	"./blog--we-just-open-sourced-flanker-our-python-email-address-and-mime-parsing-library.json": 925,
	"./blog--we-stand-with-the-aapi-community": 926,
	"./blog--we-stand-with-the-aapi-community.json": 926,
	"./blog--weekly-product-update-50-better-database-performance-and-moving-to-mailgun-com": 927,
	"./blog--weekly-product-update-50-better-database-performance-and-moving-to-mailgun-com.json": 927,
	"./blog--weekly-product-update-access-mailgun-directly-through-the-rackspace-cloud-control-panel": 928,
	"./blog--weekly-product-update-access-mailgun-directly-through-the-rackspace-cloud-control-panel.json": 928,
	"./blog--weekly-product-update-control-panel-improvements-and-135x-faster-spell-checker-for-email-validation": 929,
	"./blog--weekly-product-update-control-panel-improvements-and-135x-faster-spell-checker-for-email-validation.json": 929,
	"./blog--weekly-product-update-domain-level-webhooks-and-reputation-system-improvements": 930,
	"./blog--weekly-product-update-domain-level-webhooks-and-reputation-system-improvements.json": 930,
	"./blog--weekly-product-update-easy-testing-for-routes-webhooks": 931,
	"./blog--weekly-product-update-easy-testing-for-routes-webhooks.json": 931,
	"./blog--weekly-product-update-improved-notifications-for-email-limits": 932,
	"./blog--weekly-product-update-improved-notifications-for-email-limits.json": 932,
	"./blog--weekly-product-update-improved-reputation-system-makes-life-hard-on-spammers": 933,
	"./blog--weekly-product-update-improved-reputation-system-makes-life-hard-on-spammers.json": 933,
	"./blog--weekly-product-update-improved-status-page-lets-you-get-alerts-by-sms-webhook": 934,
	"./blog--weekly-product-update-improved-status-page-lets-you-get-alerts-by-sms-webhook.json": 934,
	"./blog--weekly-product-update-improvements-to-email-validation-api": 935,
	"./blog--weekly-product-update-improvements-to-email-validation-api.json": 935,
	"./blog--weekly-product-update-increased-character-limit-for-link-rewriting-and-account-management-improvements": 936,
	"./blog--weekly-product-update-increased-character-limit-for-link-rewriting-and-account-management-improvements.json": 936,
	"./blog--weekly-product-update-mailgun-default-smtp-config-for-rackspace-managed-cloud-plus-better-search-on-docs": 937,
	"./blog--weekly-product-update-mailgun-default-smtp-config-for-rackspace-managed-cloud-plus-better-search-on-docs.json": 937,
	"./blog--weekly-product-update-manage-your-webhooks-programatically-with-new-api": 938,
	"./blog--weekly-product-update-manage-your-webhooks-programatically-with-new-api.json": 938,
	"./blog--weekly-product-update-new-events-api-available-for-private-beta": 939,
	"./blog--weekly-product-update-new-events-api-available-for-private-beta.json": 939,
	"./blog--weekly-product-update-no-charge-for-inbound-email-and-self-service-dedicated-ips": 940,
	"./blog--weekly-product-update-no-charge-for-inbound-email-and-self-service-dedicated-ips.json": 940,
	"./blog--weekly-product-update-say-hello-to-the-domains-api": 941,
	"./blog--weekly-product-update-say-hello-to-the-domains-api.json": 941,
	"./blog--weekly-product-update-support-center-and-improvements-to-domains-and-events-apis": 942,
	"./blog--weekly-product-update-support-center-and-improvements-to-domains-and-events-apis.json": 942,
	"./blog--weekly-product-update-test-all-the-webhooks": 943,
	"./blog--weekly-product-update-test-all-the-webhooks.json": 943,
	"./blog--weekly-product-update-tips-for-configuring-ssl-termination-on-cloud-load-balancers": 944,
	"./blog--weekly-product-update-tips-for-configuring-ssl-termination-on-cloud-load-balancers.json": 944,
	"./blog--weekly-product-update-try-our-new-domains-api-now-in-private-beta": 945,
	"./blog--weekly-product-update-try-our-new-domains-api-now-in-private-beta.json": 945,
	"./blog--weekly-product-update-upgrading-to-mongodb-2-4-1": 946,
	"./blog--weekly-product-update-upgrading-to-mongodb-2-4-1.json": 946,
	"./blog--weekly-product-update-validate-dns-records-using-the-domains-api": 947,
	"./blog--weekly-product-update-validate-dns-records-using-the-domains-api.json": 947,
	"./blog--welcoming-email-on-acid": 948,
	"./blog--welcoming-email-on-acid.json": 948,
	"./blog--what-happened-yesterday-and-what-we-are-doing-about-it": 949,
	"./blog--what-happened-yesterday-and-what-we-are-doing-about-it.json": 949,
	"./blog--what-is-transactional-email-basics": 950,
	"./blog--what-is-transactional-email-basics.json": 950,
	"./blog--what-to-do-about-mass-email-typo-marketing-email-mistake": 951,
	"./blog--what-to-do-about-mass-email-typo-marketing-email-mistake.json": 951,
	"./blog--what-toasters-and-distributed-systems-might-have-in-common": 952,
	"./blog--what-toasters-and-distributed-systems-might-have-in-common.json": 952,
	"./blog--what-we-learned-open-sourcing-a-major-part-of-mailgun": 953,
	"./blog--what-we-learned-open-sourcing-a-major-part-of-mailgun.json": 953,
	"./blog--whats-cool-about-coil": 954,
	"./blog--whats-cool-about-coil.json": 954,
	"./blog--when-should-you-use-email-api": 955,
	"./blog--when-should-you-use-email-api.json": 955,
	"./blog--when-transactional-email-preps-4-million-contracts-e-signature-every-month": 956,
	"./blog--when-transactional-email-preps-4-million-contracts-e-signature-every-month.json": 956,
	"./blog--which-smtp-port-understanding-ports-25-465-587": 957,
	"./blog--which-smtp-port-understanding-ports-25-465-587.json": 957,
	"./blog--white-labeling-dns-records-your-customers-tips-tricks": 958,
	"./blog--white-labeling-dns-records-your-customers-tips-tricks.json": 958,
	"./blog--why-automated-transactional-emails-are-critical-to-your-growth": 959,
	"./blog--why-automated-transactional-emails-are-critical-to-your-growth.json": 959,
	"./blog--why-email-validation-is-vital-for-your-inbox": 960,
	"./blog--why-email-validation-is-vital-for-your-inbox.json": 960,
	"./blog--women-in-tech-amy-jessica-and-lola": 961,
	"./blog--women-in-tech-amy-jessica-and-lola.json": 961,
	"./blog--wordpress-plugins-for-mailgun": 962,
	"./blog--wordpress-plugins-for-mailgun.json": 962,
	"./blog--xml-over-http-mailgun-api": 963,
	"./blog--xml-over-http-mailgun-api.json": 963,
	"./blog--yahoo-aol-throttling-mailgun-festivus-airing-grievances-part-two": 964,
	"./blog--yahoo-aol-throttling-mailgun-festivus-airing-grievances-part-two.json": 964,
	"./blog--your-guide-to-webhooks": 965,
	"./blog--your-guide-to-webhooks.json": 965,
	"./blog--zero-inbox-notes": 966,
	"./blog--zero-inbox-notes.json": 966,
	"./blog--zipbooks-switched-from-mandrill-to-mailgun-using-laravel": 967,
	"./blog--zipbooks-switched-from-mandrill-to-mailgun-using-laravel.json": 967,
	"./blogCategories": 568,
	"./blogCategories.json": 568,
	"./blogListings": 437,
	"./blogListings.json": 437,
	"./case-studies--behind-the-scene-at-jungle-disk-reliable-email-communications-with-mailgun": 968,
	"./case-studies--behind-the-scene-at-jungle-disk-reliable-email-communications-with-mailgun.json": 968,
	"./case-studies--bringing-professionals-closer-to-their-dream-job-with-transactional-email": 969,
	"./case-studies--bringing-professionals-closer-to-their-dream-job-with-transactional-email.json": 969,
	"./case-studies--causes-experiences-20-increase-in-clicks": 970,
	"./case-studies--causes-experiences-20-increase-in-clicks.json": 970,
	"./case-studies--embracing-growth-the-omnisend-story": 971,
	"./case-studies--embracing-growth-the-omnisend-story.json": 971,
	"./case-studies--finding-the-perfect-match-through-email-marketing": 972,
	"./case-studies--finding-the-perfect-match-through-email-marketing.json": 972,
	"./case-studies--flipsnack-better-user-experience-email-validations": 973,
	"./case-studies--flipsnack-better-user-experience-email-validations.json": 973,
	"./case-studies--growing-digital-storefronts-with-mailgun-and-drupal": 974,
	"./case-studies--growing-digital-storefronts-with-mailgun-and-drupal.json": 974,
	"./case-studies--how-dribbble-improved-connection-and-scalable-sending-with-mailgun": 975,
	"./case-studies--how-dribbble-improved-connection-and-scalable-sending-with-mailgun.json": 975,
	"./case-studies--how-geogram-built-a-free-group-email-service-using-yii-for-php-with-mysql": 976,
	"./case-studies--how-geogram-built-a-free-group-email-service-using-yii-for-php-with-mysql.json": 976,
	"./case-studies--how-kanban2go-fulfills-zawinskis-law": 977,
	"./case-studies--how-kanban2go-fulfills-zawinskis-law.json": 977,
	"./case-studies--how-ruby-based-dnsimple-uses-mailguns-api-to-create-2": 978,
	"./case-studies--how-ruby-based-dnsimple-uses-mailguns-api-to-create-2.json": 978,
	"./case-studies--how-ruby-based-vero-uses-mailguns-campaign-analytics": 979,
	"./case-studies--how-ruby-based-vero-uses-mailguns-campaign-analytics.json": 979,
	"./case-studies--how-tealeaf-academy-increased-student-engagement-3x": 980,
	"./case-studies--how-tealeaf-academy-increased-student-engagement-3x.json": 980,
	"./case-studies--how-userfox-sends-tracks-emails-in-their-ruby-app": 981,
	"./case-studies--how-userfox-sends-tracks-emails-in-their-ruby-app.json": 981,
	"./case-studies--how-uservoice-solve-their-incoming-email-problem": 982,
	"./case-studies--how-uservoice-solve-their-incoming-email-problem.json": 982,
	"./case-studies--how-zapier-uses-mailgun-to-send-emails": 983,
	"./case-studies--how-zapier-uses-mailgun-to-send-emails.json": 983,
	"./case-studies--mailgun-and-trancend-case-study": 984,
	"./case-studies--mailgun-and-trancend-case-study.json": 984,
	"./case-studies--mailgun-cinemark-case-study": 985,
	"./case-studies--mailgun-cinemark-case-study.json": 985,
	"./case-studies--mailgun-dovetail-a-recipe-for-rapid-growth": 986,
	"./case-studies--mailgun-dovetail-a-recipe-for-rapid-growth.json": 986,
	"./case-studies--marketing-automation-at-scale-customer-io-mailgun": 987,
	"./case-studies--marketing-automation-at-scale-customer-io-mailgun.json": 987,
	"./case-studies--samba-ai-growing-fast-and-growing-smart-with-mailgun": 988,
	"./case-studies--samba-ai-growing-fast-and-growing-smart-with-mailgun.json": 988,
	"./case-studies--sending-millions-of-job-alerts-24-7-with-the-mailgun-email-ap": 989,
	"./case-studies--sending-millions-of-job-alerts-24-7-with-the-mailgun-email-ap.json": 989,
	"./case-studies--textmagic-improves-deliverability-rate-with-mailgun": 990,
	"./case-studies--textmagic-improves-deliverability-rate-with-mailgun.json": 990,
	"./case-studies--zipbooks-switched-from-mandrill-to-mailgun-using-laravel": 991,
	"./case-studies--zipbooks-switched-from-mandrill-to-mailgun-using-laravel.json": 991,
	"./events--activate-19": 992,
	"./events--activate-19.json": 992,
	"./events--email-evolution": 993,
	"./events--email-evolution.json": 993,
	"./events--mailcon-nyc": 994,
	"./events--mailcon-nyc.json": 994,
	"./events--mailgun-ongage-happy-hour": 995,
	"./events--mailgun-ongage-happy-hour.json": 995,
	"./guides--email-supply-chain-communication": 996,
	"./guides--email-supply-chain-communication.json": 996,
	"./guides--master-the-art-of-inboxing-with-this-checklist": 997,
	"./guides--master-the-art-of-inboxing-with-this-checklist.json": 997,
	"./guides--migrating-from-mailchimp-transactional-to-mailgun-email-api": 998,
	"./guides--migrating-from-mailchimp-transactional-to-mailgun-email-api.json": 998,
	"./guides--migrating-from-sendgrid-to-mailgun-email-api": 999,
	"./guides--migrating-from-sendgrid-to-mailgun-email-api.json": 999,
	"./guides--understanding-email-deliverability": 1000,
	"./guides--understanding-email-deliverability.json": 1000,
	"./guides--your-guide-to-webhooks": 1001,
	"./guides--your-guide-to-webhooks.json": 1001,
	"./podcasts--apple-privacy-policy": 1002,
	"./podcasts--apple-privacy-policy.json": 1002,
	"./podcasts--combatting-email-fraud-with-bimi": 1003,
	"./podcasts--combatting-email-fraud-with-bimi.json": 1003,
	"./podcasts--complaints-and-unsubscribes": 1004,
	"./podcasts--complaints-and-unsubscribes.json": 1004,
	"./podcasts--email-camp-2020": 1005,
	"./podcasts--email-camp-2020.json": 1005,
	"./podcasts--email-changes-2021": 1006,
	"./podcasts--email-changes-2021.json": 1006,
	"./podcasts--implementing-dmarc": 1007,
	"./podcasts--implementing-dmarc.json": 1007,
	"./podcasts--inbox-insights-2022": 1008,
	"./podcasts--inbox-insights-2022.json": 1008,
	"./podcasts--inbox-placement": 1009,
	"./podcasts--inbox-placement.json": 1009,
	"./podcasts--insights-emailmarketer-emaildeveloper": 1010,
	"./podcasts--insights-emailmarketer-emaildeveloper.json": 1010,
	"./podcasts--now-that-is-what-i-call-spam": 1011,
	"./podcasts--now-that-is-what-i-call-spam.json": 1011,
	"./podcasts--really-good-emails": 1012,
	"./podcasts--really-good-emails.json": 1012,
	"./podcasts--send-time-optimization": 1013,
	"./podcasts--send-time-optimization.json": 1013,
	"./podcasts--sending-a-more-relevant-message-with-omnichannel-communication": 1014,
	"./podcasts--sending-a-more-relevant-message-with-omnichannel-communication.json": 1014,
	"./podcasts--sending-funnel-global-crisis": 1015,
	"./podcasts--sending-funnel-global-crisis.json": 1015,
	"./podcasts--spoofing-phishing-dmarcian": 1016,
	"./podcasts--spoofing-phishing-dmarcian.json": 1016,
	"./podcasts--sunset-policy-and-tracking": 1017,
	"./podcasts--sunset-policy-and-tracking.json": 1017,
	"./podcasts--tales-of-terror-2020": 1018,
	"./podcasts--tales-of-terror-2020.json": 1018,
	"./podcasts--the-devisode": 1019,
	"./podcasts--the-devisode.json": 1019,
	"./podcasts--the-history-of-spam": 1020,
	"./podcasts--the-history-of-spam.json": 1020,
	"./podcasts--when-email-goes-wrong-laura-atkins": 1021,
	"./podcasts--when-email-goes-wrong-laura-atkins.json": 1021,
	"./podcasts--where-were-going-we-dont-need-spam": 1022,
	"./podcasts--where-were-going-we-dont-need-spam.json": 1022,
	"./videos--3mistakes-that-can-ruin-your-email-lists": 1023,
	"./videos--3mistakes-that-can-ruin-your-email-lists.json": 1023,
	"./videos--4-email-personalization-tricks": 1024,
	"./videos--4-email-personalization-tricks.json": 1024,
	"./videos--ama-webhooks-and-routes": 1025,
	"./videos--ama-webhooks-and-routes.json": 1025,
	"./videos--bulk-email-validation-api": 1026,
	"./videos--bulk-email-validation-api.json": 1026,
	"./videos--dedicated-ips": 1027,
	"./videos--dedicated-ips.json": 1027,
	"./videos--ecommerce-holiday-campaigns": 1028,
	"./videos--ecommerce-holiday-campaigns.json": 1028,
	"./videos--email-best-practices": 1029,
	"./videos--email-best-practices.json": 1029,
	"./videos--email-deliverability-understanding-the-roadblocks-and-path-to-success": 1030,
	"./videos--email-deliverability-understanding-the-roadblocks-and-path-to-success.json": 1030,
	"./videos--email-explained-part-1": 1031,
	"./videos--email-explained-part-1.json": 1031,
	"./videos--email-explained-part-2": 1032,
	"./videos--email-explained-part-2.json": 1032,
	"./videos--email-explained-part-3": 1033,
	"./videos--email-explained-part-3.json": 1033,
	"./videos--email-validation-101": 1034,
	"./videos--email-validation-101-2": 1035,
	"./videos--email-validation-101-2.json": 1035,
	"./videos--email-validation-101-what-goes-into-an-email-address": 1036,
	"./videos--email-validation-101-what-goes-into-an-email-address.json": 1036,
	"./videos--email-validation-101.json": 1034,
	"./videos--email-validation-api": 1037,
	"./videos--email-validation-api.json": 1037,
	"./videos--email-validation-what-is-it": 1038,
	"./videos--email-validation-what-is-it.json": 1038,
	"./videos--eu-announcement": 1039,
	"./videos--eu-announcement.json": 1039,
	"./videos--future-proofing-your-customer-data-with-email-validations": 1040,
	"./videos--future-proofing-your-customer-data-with-email-validations.json": 1040,
	"./videos--getting-started-mailgun-intro-platform": 1041,
	"./videos--getting-started-mailgun-intro-platform.json": 1041,
	"./videos--getting-started-with-mailgun": 1042,
	"./videos--getting-started-with-mailgun.json": 1042,
	"./videos--innovation-in-email-in-the-current-climate": 1043,
	"./videos--innovation-in-email-in-the-current-climate.json": 1043,
	"./videos--introducing-inbox-placement": 1044,
	"./videos--introducing-inbox-placement.json": 1044,
	"./videos--just-getting-started-mailguns-ama": 1045,
	"./videos--just-getting-started-mailguns-ama.json": 1045,
	"./videos--mailgun-and-ongage-virtual-happy-hour": 1046,
	"./videos--mailgun-and-ongage-virtual-happy-hour.json": 1046,
	"./videos--new-mailgun-dashboard": 1047,
	"./videos--new-mailgun-dashboard.json": 1047,
	"./videos--predictions-and-resolutions-sending-in-2019": 1048,
	"./videos--predictions-and-resolutions-sending-in-2019.json": 1048,
	"./videos--pytexas-using-python-send-email": 1049,
	"./videos--pytexas-using-python-send-email.json": 1049,
	"./videos--sending-self-esteem": 1050,
	"./videos--sending-self-esteem.json": 1050,
	"./videos--tales-of-terror": 1051,
	"./videos--tales-of-terror-2020": 1052,
	"./videos--tales-of-terror-2020.json": 1052,
	"./videos--tales-of-terror-from-the-email-void-2019": 1053,
	"./videos--tales-of-terror-from-the-email-void-2019.json": 1053,
	"./videos--tales-of-terror.json": 1051,
	"./videos--the-most-relied-upon-email-platform": 1054,
	"./videos--the-most-relied-upon-email-platform.json": 1054,
	"./videos--tips-for-building-html-emails-and-workflow": 1055,
	"./videos--tips-for-building-html-emails-and-workflow.json": 1055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1161;